import React from 'react';

const P = {
  fontSize: '1.0625rem',
  lineHeight: 1.85,
  color: 'var(--gray)',
  marginBottom: '1.5rem',
  fontWeight: 300,
  maxWidth: '68ch'
};

// Secção 2 · O problema (fundo claro)
export const HerancasContextSection = () => (
  <section
    className="valuare-section"
    style={{ background: 'var(--cream)' }}
    data-testid="herancas-context-section"
  >
    <div className="valuare-section-content">
      <div style={{ maxWidth: '820px', margin: '0 auto', textAlign: 'left' }}>
        <div className="valuare-section-label">O Contexto</div>
        <h2 className="valuare-section-title">
          Milhares de imóveis parados em<br />
          <em>impasses sucessórios</em>
        </h2>
        <p style={P}>
          Estima-se que cerca de 3,4 milhões de prédios rústicos e aproximadamente 500 mil
          habitações urbanas se encontrem retidos em heranças por partilhar em Portugal. Na
          maioria dos casos o bloqueio não resulta de litígio declarado, mas da ausência de
          acordo quanto ao valor a atribuir ao imóvel.
        </p>
        <p style={{ ...P, marginBottom: 0 }}>
          Enquanto esse valor não estiver fixado com fundamento técnico, a partilha não avança,
          o imóvel não entra no mercado e os encargos continuam a correr por conta de todos.
        </p>
      </div>
    </div>
  </section>
);
